import {
  fixedPageDataFetcher,
  FixedPageTemplate,
} from "components/templates/FixedPage";

export default FixedPageTemplate;

export async function getServerSideProps(context) {
  const { props } = await fixedPageDataFetcher(context, {
    path: "/articles",
  });

  if (props.error) {
    return {
      redirect: {
        destination: `/${context.locale}/news`,
        permanent: false,
      },
    };
  }
  return { props };
}
